import { Injectable } from "@angular/core";
import { PointOfSaleDetails, PointOfSaleSummary } from "../../api/fulle/fulle-pointOfSale/fulle-pointOfSale.service.interface";

@Injectable({
    providedIn: 'root'
})
export class LogoAndBannerService {

    initLogoAndBannerDetails(currPoint: PointOfSaleDetails, bannerSize: number = 1920, logoSize: number = 72): Promise<PointOfSaleDetails> {
        return new Promise((resolve) => {
            if (currPoint) {
                // console.log("currPoint : ", currPoint);
                if (currPoint.banner) {
                    currPoint.banner = currPoint.banner ? 
                        this.transformLogoOrBannerSizes(currPoint.banner, bannerSize) : "";
                }
                if (currPoint.img) {
                    currPoint.img = currPoint.img ? 
                        this.transformLogoOrBannerSizes(currPoint.img, logoSize) : "";
                }
            }
            resolve(currPoint);
        });
    }

    initLogoAndBannerSummary(currPoint: PointOfSaleSummary, bannerSize: number = 1920, logoSize: number = 72): Promise<PointOfSaleSummary> {
        return new Promise((resolve) => {
            if (currPoint) {
                // console.log("currPoint : ", currPoint);
                if (currPoint.banner) {
                    currPoint.banner = currPoint.banner ? 
                        this.transformLogoOrBannerSizes(currPoint.banner, bannerSize) : "";
                }
                if (currPoint.img) {
                    currPoint.img = currPoint.img ? 
                        this.transformLogoOrBannerSizes(currPoint.img, logoSize) : "";
                }
            }
            resolve(currPoint);
        });
    }

    transformLogoOrBannerSizes(value: string, size: number): string {
        // Vérifier que value est bien une chaîne de caractères
        if (!value || typeof value !== 'string') {
            return "";
        }
        const newValue = value.replace("%WIDTHx%HEIGHT", size + "x" + size);
        return newValue;
    }
}
